(function(){
  function setupHover(){
    if(!window.matchMedia('(min-width: 990px)').matches) return;
    document.querySelectorAll('header-menu > details').forEach(function(d){
      if(d.dataset.rozeaHover) return;
      d.dataset.rozeaHover = '1';
      var closeTimer;
      d.addEventListener('mouseenter', function(){
        clearTimeout(closeTimer);
        document.querySelectorAll('header-menu > details[open]').forEach(function(o){
          if(o !== d){
            o.removeAttribute('open');
            var s = o.querySelector('summary');
            if(s) s.setAttribute('aria-expanded','false');
          }
        });
        d.setAttribute('open','');
        var s = d.querySelector('summary');
        if(s) s.setAttribute('aria-expanded','true');
      });
      d.addEventListener('mouseleave', function(){
        closeTimer = setTimeout(function(){
          d.removeAttribute('open');
          var s = d.querySelector('summary');
          if(s) s.setAttribute('aria-expanded','false');
        }, 200);
      });
    });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', setupHover);
  } else {
    setupHover();
  }
  document.addEventListener('shopify:section:load', setupHover);
})();
